import CourseInfoPanel from './CourseInfoPanel';

export default CourseInfoPanel;
